module.exports = __webpack_public_path__ + "static/media/map.12b61ab6.svg";